'use client';
import { SignoutButton } from '@/components/user-profile/SignoutButton';
import { authClient } from '@/lib/auth-client';
import { useTranslations } from 'next-intl';

const GlobalErrorSignout = () => {
  const t = useTranslations('UserMenu.logoutButton');
  const { data, error } = authClient.useSession();

  if (!data?.session || error) return null;
  return (
    <SignoutButton className="absolute top-12 right-16 rounded-full">{t('label')}</SignoutButton>
  );
};

export default GlobalErrorSignout;
